import React, { useState, useEffect } from "react";
import { sendData, getData } from "../services/auth";
import { uriList } from "../helpers/config";
import { Modal } from "react-bootstrap";
import { Button } from "reactstrap";
import { setEmpresaID } from "./../store/login";
import { useDispatch, useSelector } from "react-redux";
import { width } from '../helpers'
import {
  WriteDataStorage,
  ReadDataStorage,
  EMP_DATA,
} from "./../services/auth";

const SelEmpresas = (props) => {
  const [empresas, setEmpresas] = useState([]);
  const [empresa, setEmpresa] = useState({});
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const _login = useSelector((state) => state.login);

  async function _getData() {
    await sendData({
      uri: uriList("selecionarEmpresas"),
      content: { usuarioid: _login.usuarioid },
    })
      .then((res) => {
        console.log("selEmpresas._getData: ", res);

        if (res.status && parseInt(res.status) > 200) throw new Error();
        if (res?.data?.length === 1) {
          setEmpresa(res?.data[0]);
          handleEmpresa(res?.data[0]);
        } else {
          setEmpresas(res?.data || res);
          setShow(true);
        }
      })
      .catch((e) => {
        setShow(true);
        console.log(e);
        alert("Erro ao obter Empresas.\n" + e.message);
      });
  }

  useEffect(() => {
    _getData();
  }, []);

  async function handleEmpresa(_empresa = null) {
    const _empresa_ = _empresa || empresa;
    console.log("selEmpresas.handleEmpresa: ", _empresa_);
    await WriteDataStorage(EMP_DATA, JSON.stringify({ ..._empresa_ }));
    dispatch(setEmpresaID(_empresa_?.EMPRESAID || _empresa_?.empresaid));

    console.log("selEmpresas.handleEmpresa: ", _empresa_);

    if (props.handleEmpresa) props.handleEmpresa();
  }

  async function handle(empresa) {
    setEmpresa(empresa);
  }

  return (
    <>
      {show &&
        <Modal size={width() === "mobile" ? "sm" : "md"} show={true} centered animation={false} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <span>Seleção de Empresas</span>
            </Modal.Title>
          </Modal.Header>
          <div className="p-2 col-12 align-items-center justify-content-center vertical">
            <table className="table col-12 table-bordered table-hover table-sm ">
              <tbody>
                {empresas?.map((_emp) => {
                  return (
                    <tr style={{ cursor: "pointer" }}
                      className={`${_emp?.EMPRESAID === empresa?.EMPRESAID
                        ? "bg-secondary text-light font-weight-bold"
                        : ""
                        }`}
                      onClick={() => handle(_emp)}
                    >
                      <td scope="row" style={{ fontSize: `${width() === 'mobile' ? "10px" : "14px"} ` }} >
                        {_emp.nome || _emp.NOME || _emp.EMPRESA}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Modal.Footer>
            <Button color="success" onClick={() => handleEmpresa(empresa)}>
              Selecionar
            </Button>
          </Modal.Footer>
        </Modal>}
    </>
  );
};

export default SelEmpresas;
